export const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage';
